<template>
    <div class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-20 backdrop-blur-[2px]">
    </div>
    <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center z-40 max-sm:left-[3%] max-sm:right-[3%]">
        <div class="flex flex-col justify-center  z-40 bg-white text-lg rounded-lg border-[2px] border-[#006A00] relative w-[1000px]">
            <div v-if="loading" class="absolute bg-[#00000042] w-full h-full rounded-lg  flex justify-center items-center z-0" >
                <span class="loader z-50"></span>
            </div>
            <div class="pafcpic_header bg-[#016B00] py-3 px-6 rounded-t-sm flex justify-between items-center">
                <p class="text-[#ffffff] text-sm font-semibold ">REFERENCE NO.: {{ data.ref_no }}</p>
                <button class="text-white text-lg font-bold hover:text-[#e9e7e7] max-sm:text-xs"  @click="$emit('close')" >X</button>
            </div>
            <div class="pafcpic_body py-6 px-6">
                <div class="font-semibold text-[#016B00] text-center mb-6 max-sm:text-left">
                    {{ getEmployeename(data.employee_key) }}
                </div>
                <div class="grid grid-cols-4 gap-4 text-sm w-[100%] max-sm:text-xs">
                    <p class="col-span-1 font-semibold text-[#929492]">Total Duration:</p>
                    <div class="col-span-3 font-semibold text-[#016B00]">
                        {{ data.duration + " "}}DAY(S)
                    </div>
                    <p class="col-span-1 font-semibold text-[#929492]">Reason:</p>
                    <div class="col-span-3 font-semibold text-[#016B00] break-words">
                        {{ data.reason }}
                    </div>
                    <div class="col-span-4 flex flex-col gap-1 w-full">
                        <div class=" overflow-auto">
                            <table class="w-full overflow-auto">
                                <tr class="bg-[#016B00] w-full text-white max-sm:text-xs">
                                    <th>FROM</th>
                                    <th>TO</th>
                                    <th>CATEGORY</th>
                                    <th>TIME(UNDERTIME)</th>
                                    <th>DURATION</th>
                                </tr>
                                <tr v-for="(data,index) in info" :key="index" class="max-sm:text-xs">
                                    <td>{{ data.from_date}}</td>
                                    <td>{{ data.to_date  }}</td>
                                    <td>{{ getFullDescription(data.category)  }}</td>
                                    <td v-if="!data.undertime">N/A</td>
                                    <td v-else>{{ data.time  }}</td>
                                    <td v-if="data.duration > 1">{{ data.duration + " " }}   DAY(S)</td>
                                    <td v-else>{{ data.duration  }}   DAY</td>
                                </tr>
                            </table>
                        </div>
                        <div class="mt-5 py-5 border-[#b6b5b5] border-t border-b px-2 max-h-[200px] overflow-auto">
                            <div class="flex gap-5 max-sm:text-xs">
                                <div class="w-full flex flex-col gap-2 max-sm:text-xs text-sm">
                                  <label class=" text-[#6A6A6A] font-semibold">Recommended by:</label>
                                    <div v-if="recommendation == ''">
                                      <p class=" text-[#a5a5a5]">NO SIGNATORY FOUND</p>
                                    </div>
                                    <div v-else v-for="(recon,index) in recommendation" :key="index" class="">
                                      <p class=" font-semibold  " :class="{'text-[#016B00]': recon.status === 'A','text-[#792424]': recon.status == 'D','text-[#8d8d8d]': !recon.status}">{{recon.employee_name}}</p>
                                      <label class=" text-[#6A6A6A]">{{ recon.position_name}}</label>
                                      <div v-if="recon.status == 'D'">
                                        <label v-if="recon.remarks" class=" font-semibold text-[#6A6A6A]">Remarks:</label>
                                        <p class="font-semibold text-[#792424]"> {{recon.remarks}}</p>
                                      </div>
                                    </div>
                                </div>
                                <div class=" w-full flex flex-col gap-2 max-sm:text-xs text-sm">
                                  <label class="text-[#6A6A6A] font-semibold">Approved by:</label>
                                  <div v-if="approval == ''">
                                    <p class=" text-[#a5a5a5]">NO SIGNATORY FOUND</p>
                                  </div>
                                  <div v-else v-for="(approval,index) in approval" :key="index" class="">
                                    <div v-if="approval != null">
                                        <div class="flex relative w-auto">
                                            <p class="font-semibold " :class="{'text-[#016B00]': approval.status == 'A','text-[#792424]': approval.status == 'D','text-[#8d8d8d]': !approval.status}">{{approval.employee_name}}</p>
                                        </div>
                                      <label class=" text-[#6A6A6A]">{{ approval.position_name}}</label>
                                      <div v-if="approval.status == 'D'">
                                            <label v-if="approval.remarks" class="font-semibold text-[#6A6A6A]">Remarks:</label>
                                            <p class=" font-semibold text-[#792424]"> {{approval.remarks}}</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                          </div>
                    </div>
                </div>
            </div>
        <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
            <button class="text-sm text-white bg-[#016B00] py-2 px-7 rounded-sm hover:bg-[#026b00bb] w-[150px]" 
                v-if="apv && data.status === 'APPROVED' && data.encoded_datetime === null" 
                @click="$emit('encode', data.ref_no)" >
                Encode</button>
            <button class="text-sm text-white bg-[#016B00] py-2 px-7 rounded-sm hover:bg-[#026b00bb] w-[150px]" 
                v-if="apv && data.status === 'APPROVED' && data.encoded_datetime != null && data.checked_datetime === null" 
                @click="$emit('encode', data.ref_no)">
                Check</button>

            <!-- <button class="text-sm text-[#ffffff] bg-[#9b2b2b] py-2 px-7 rounded-sm  hover:bg-[#9b2b2bb0] w-[150px]" v-if="apv" @click="$emit('disapproveRequest', data.ref_no)">DISAPPROVE</button> -->
            <!-- <button class="text-sm text-[#ffffff] bg-[#860000] py-2 px-7 rounded-sm hover:bg-[#5a0101] w-[200px]" v-if="data.status != 'CANCELLED' && data.status!='DISAPPROVED' && sign && cancel" @click="$emit('cancelrequest', data.ref_no)">CANCEL REQUEST</button> -->
        </div>
    </div>
    </div>

</template>

<script>

import { defineComponent } from "vue";
import LeaveRequest from "@/services/leaverequest";

export default defineComponent({
components: {
   
},
data() {
    return {
        lvkey:null,
        info:'',
        loading:false,
        signatory: null,
        recommendation:'',
        approval:'',
        sign:false
    }
},
props: {
    data: {
        type: Object,
        default: null,
    },
    apv: {
        type: Boolean,
        default: false,
    },
},

mounted() {
   this.lvkey = this.Data
   this.getCoveredDate()
},
methods:{
    getEmployeename(emp_key){
      return this.$store.state.list_employee.find(e=> e.key == emp_key)?.value ?? ''
    },
    getFullDescription(type){

        if(type == "WHL" )
        {
            return "WHOLE DAY"
        }
        else if(type == "UND")
        {
            return "UNDERTIME"
        }
        else if(type == "HAM")
        {
            return "HALF DAY(AM)"
        }
        else if(type == "HPM")
        {
            return "HALF DAY(PM)" 
        }
    },
    async getCoveredDate(){
      this.loading        = true
      let that = this
      await LeaveRequest.getLeaveCoveredDate(this.data.ref_no).then(function(response){
        that.info           = response.data.data.leave_info
        that.getLeaveSignatory(response.data.data.leave_signatory)
      }).catch(function(){
         that.info = ''
      });
      this.loading        = false
    },
    async getLeaveSignatory(signatory){
      this.loading           = true
      this.signatorys        = signatory
      
      if(this.signatorys!=null )
      {
        this.recommendation = this.signatorys.filter(signatory=>signatory.rank == 'R')
        this.approval       = this.signatorys.filter(signatory=>signatory.rank == 'A')
        this.sign           = this.signatorys.some(e=>e.date != null) ? false : true

        if(this.approval.length == 0){
            this.approval = null
        }
      }
      
      this.loading        = false
    }


}
})

</script>

<style scoped>
    table tr th{
        padding: 7px 0px;
    }
    table tr td{
        border-bottom: 1px solid rgb(228, 226, 226);
        padding: 10px 10px ;
        color: rgb(48, 49, 49);
        text-align: center;
    }
    .loader {
        width: 48px;
        height: 48px;
        border: 5px solid #ffffff;
        border-bottom-color: transparent;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
    }
    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    } 
</style>